import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBranchUserRoles, assignUserRole } from "../../api/role.api";
import "./BranchUsers.css";

export default function BranchUsers() {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const navigate = useNavigate();

    const branch = JSON.parse(localStorage.getItem("branch"));

    useEffect(() => {
        const storedUsers =
            JSON.parse(localStorage.getItem("branch_users")) || [];
        setUsers(storedUsers);

        loadRoles();
    }, []);

    useEffect(() => {
        const hasUnassigned = users.some((u) => u.role_id === null);
        if (users.length && !hasUnassigned) {
            navigate("/dashboard");
        }
    }, [users]);

    const loadRoles = async () => {
        const data = await getBranchUserRoles(branch.id);
        setRoles(data);
    };

    const handleAssign = async (userId, roleId) => {
        if (!roleId) return;

        const updatedUser = await assignUserRole(userId, roleId);

        const updated = users.map((u) =>
            u.id === userId ? { ...u, role_id: roleId } : u
        );

        setUsers(updated);
        localStorage.setItem("branch_users", JSON.stringify(updated));
    };

    return (
        <div className="assign-container">
            <h2>Assign Roles</h2>

            {users
                .filter((u) => u.role_id === null)
                .map((user) => (
                    <div key={user.id} className="assign-card">
                        <span>{user.name}</span>

                        <select
                            defaultValue=""
                            onChange={(e) =>
                                handleAssign(user.id, Number(e.target.value))
                            }
                        >
                            <option value="">Select role</option>

                            {roles.map((role) => (
                                <option key={role.id} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </select>
                    </div>
                ))}
        </div>
    );
}
